module.exports = __webpack_public_path__ + "static/media/29.dd684b32.png";